export default __webpack_public_path__ + "static/media/material-symbols_full-stacked-bar-chart.f7dbe295.svg";